<template>
  <!-- 首页 第四块 -->
  <div class="mcont4">
    <!-- 关于我们 -->
    <!-- <div class="forme"></div> -->
    <div class="about-us">{{ title }}</div>
    <!-- 描述一 -->
    <div class="m4-mid">
      <p>{{ firstContent }}
      </p>
      <span>With the Internet leading to a business revolution and the proliferation of smart devices driving the mobile
        information revolution, all businesses are faced with rapidly changing IT technologies, forcing them to respond
        strategically. At the same time as the social environment is changing rapidly, there is also a need to seek to
        integrate IT strategically into the business.</span>
      <!-- 图片 -->
      <div class="m4-mid-pic">
        <img src="@/assets/images/new/room2.png">
        <img src="@/assets/images/new/room3.png">
        <img src="@/assets/images/new/room4.png">
      </div>
      <!-- 进场合作 collaborate-->
      <!-- <div class="m4-colla"></div> -->
    </div>
    <!-- 描述二 -->
    <div class="m4-foot">
      <p>{{ secondContent }}
      </p>
      <p>{{ thirdContent }}</p>
      <span>On the other hand, the rapid development of technologies such as cloud computing and smart devices requires
        specialized knowledge to apply them to operations.</span>
      <div>
        <img style="width: 50%; height: 250px;" src="@/assets/images/new/big-room1.png">
        <img style="width: 50%; height: 250px;" src="@/assets/images/new/big-room2.png">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  computed: {
    title() {
      return this.$store.getters.currentLang === 'zh' ? '' : ''
    },
    firstContent() {
      return this.$store.getters.currentLang === 'zh' ? '互联网引发了商业革命，智能设备的普及推动了移动信息革命等，所有企业都面临着快速变化的IT技术，迫使它们需要战略性的应对 在社会环境急剧变化的同时，也需要寻求将IT战略性地融入经营之中 ' : 'インターネットによるビジネス革命、スマートデバイスの普及によるモバイル情報革命など、あらゆる企業はIT技術の急速な変化に直面し、戦略的な対応を迫られています 社会環境が激変する中、ITを戦略的に経営に組み込むことが求められています '
    },
    secondContent() {
      return this.$store.getters.currentLang === 'zh' ? '另一方面，云计算、智能设备等技术的快速发展，需要具备专业知识才能将其应用于经营之中' : '一方で、クラウドコンピューティングやスマートデバイスなどの技術が急速に進化しているため、それを経営に活かすには専門知識が必要'
    },
    thirdContent() {
      return this.$store.getters.currentLang === 'zh' ? '在这样的经营环境下，我们可以通过利用业务知识进行提案，从系统开发、基础设施建设，到现场系统运营和维护，为经营的所有过程提供支持 我们积累了丰富的经验，持续进行提升生产效率和质量的活动，并将持续提供令客户满意的服务和解决方案' : 'そのような経営環境の中で、業務の知見を活かした提案を通じて、システム開発からインフラ構築、現場のシステム運用やメンテナンスまで、経営のあらゆるプロセスをサポートしています これまで培ってきたノウハウをもとに、生産性・品質向上活動を継続し、お客様にご満足いただけるサービス・ソリューションを提供し続けてまいります'
    },
  }
}
</script>

<style scoped lang="scss">
// 内容模块四
.about-us {
  // color: #f3f3f3;
  font-size: 2rem;
  font-weight: bold;
  margin-bottom: 30px;
}

.mcont4 {
  margin: 30px auto;
  // padding-bottom: 30px;
  width: 70%;

  p {
    font-size: 1.1rem;
    margin-bottom: 10px;
  }

  span {
    font-size: 0.7rem;
    color: #525252;
  }

  // 关于我们
  >.forme {
    position: relative;
    width: 160px;
    height: 90px;
    background-color: red;
    background: url(../../assets/images/sprite@2x.png) no-repeat;
    background-size: 270px;
    background-position: -120px -130px;

    &::after {
      position: absolute;
      top: 120px;
      content: "";
      display: block;
      width: 36px;
      height: 2px;
      background: #a38d71;
    }
  }

  >.m4-mid {
    // margin-top: 50px;
    width: 100%;
    height: 500px;
    background: $write;
    text-indent: 2em;

    >.m4-mid-pic {
      margin-top: 30px;
      width: 100%;
      height: 300px;
      display: flex;
      justify-content: space-between;
    }

    // 合作
    >.m4-colla {
      margin-top: 30px;
      width: 270px;
      height: 80px;
      background-color: red;
      background: url(../../assets/images/sprite@2x.png) no-repeat;
      background-size: 270px;
      background-position: 0px -205px;
      position: relative;

      &::after {
        content: "";
        display: block;
        width: 36px;
        height: 2px;
        background: #a38d71;
        position: absolute;
        top: 120px;
      }
    }
  }

  >.m4-foot {
    text-indent: 2em;

    >div {
      margin-top: 30px;
      display: flex;
      justify-content: space-between;
    }
  }
}
</style>


